module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7MiCdp/tc-custom/9781614238102.jpg?1738217596648",
      "alt": "This image is the cover for the book Strouss', Landmarks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Strouss', Landmarks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("More than two decades have passed since Youngstown lost its beloved Strouss' Department Store. But Youngstowners can still taste those incomparable chocolate malts, see the dramatic view from the store's mezzanine and feel the excitement of the annual Thanksgiving Day parade. The story of Strouss' kept pace with the powerful trends that defined Youngstown as a whole. This was especially true during the boom years of the early twentieth century, when the store was the shopping hub in a community known as \"America's Ruhr Valley.\" But the city changed, and Strouss' changed with it. In this unprecedented historical narrative, Welsh and Geltz dig deep into Strouss' past to uncover a dramatic story that will surprise--and delight--Youngstowners of all ages.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas Welsh, Michael Geltz, \n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Thomas G. Welsh, Ph.D., is a scholar and professional writer/editor based in Youngstown, Ohio. He sits on the advisory boards of web-based Steel Valley Voices and the Mahoning Valley Historical Society. His research has appeared in the American Educational History Journal. He worked as a journalist in the United States, South Korea and Cambodia. Michael K. Geltz is a professional writer and editor based in Youngstown, Ohio. He wrote and Web-produced for companies including Disney Consumer Products. He earned a graduate degree in English language and literature from Youngstown State University, and has contributed to technical manuals published by Microsoft Press.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0